import * as React from "react";

export const ClosedEye: React.FC<React.SVGProps<SVGSVGElement>> = ({
  color = "$gray-600",
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    color={color}
    {...rest}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      clipPath="url(#clip0_20479_366)"
    >
      <path d="M10 15.833a5.8 5.8 0 0 1-2.086-.412M17.402 10.39c-1.577 2.916-4.49 5.444-7.402 5.444M15.9 7.434c.575.674 1.087 1.41 1.502 2.177.13.242.13.536 0 .779M4.167 15.833 15.833 4.167M8.144 11.856a2.626 2.626 0 0 1 3.713-3.713"></path>
      <path d="M14.203 5.797c-1.289-.998-2.746-1.63-4.203-1.63-2.913 0-5.825 2.527-7.402 5.444a.82.82 0 0 0 0 .779c.788 1.457 1.91 2.817 3.198 3.814"></path>
    </g>
    <defs>
      <clipPath id="clip0_20479_366">
        <path fill="#fff" d="M0 0h20v20H0z"></path>
      </clipPath>
    </defs>
  </svg>
);
